import Icon from 'veui/components/Icon'
import { IconUserFilter } from 'dls-icons-vue'

Icon.register('user-filter', IconUserFilter)
